<template>
    <div>
      这是测试 --转帐

        <b-button variant="outline-primary" @click="transfer">提交</b-button>
        <br>
        <b-button variant="outline-primary" @click="getStates">信息</b-button>
        <br>

    </div>

</template>

<script>
    export default {
        name: "Test",
      data(){
          return {
            str:'',
            sonmsg: '这是子数据'
          }
      },
      methods:{
          async transfer(){
                let from = "timool"
                let to = "lemooljiang"
                let wif = ""
                let amount = "100.200 STEEM"
                let memo = "测试"
               let s = await  this.steem.broadcast.transferAsync(wif, from, to, amount, memo)
               console.log(82459, s)
               console.log(233, "okkkkkk")
            },
          async getStates(){
               let username = "timool"
              let s = await this.steem.api.getAccountsAsync([username])
              console.log(789, s[0].balance)
          }
      },

        mounted() {
            // console.log(933, this.$parent)
            // console.log(933, this.$parent.parmsg)
        }


    }
</script>

<style scoped>
  .second{
    margin-left: 1rem;
  }

  .third{
    margin-left: 2rem;
  }

</style>
